import { DIDStorage } from '@cp/shared/deviceId';

export const stubDIDStorage: DIDStorage = {
  get: () => Promise.resolve(undefined),
  set: () => Promise.resolve(),
};
